import { FC, PropsWithChildren } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { CustomerPortalDrawer } from '../navigation';
import Alert from '../organization/alert/alert';

const Wrapper: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  /* reserve the scrollbar gutter only on Settings, where the tab bar reflows
     when the scrollbar appears/disappears (avoids losing width elsewhere) */
  const stableGutter = location.pathname.startsWith('/settings');
  return (
    <div className="d-flex h-100">
      <div className="h-100">
        <CustomerPortalDrawer />
      </div>
      <div className={`flex-fill h-100 overflow-auto${stableGutter ? ' scrollbar-gutter-stable' : ''}`}>
        <Outlet />
        {children}
      </div>
      <Alert key={location.pathname} />
    </div>
  );
};

export default Wrapper;
